/* Terraloo Sleek — product page gallery + variant picker + quantity stepper */
(function () {
  'use strict';

  document.querySelectorAll('[data-tls-product-section]').forEach(function (root) {
    var thumbs = Array.from(root.querySelectorAll('[data-tls-pdp-thumb]'));
    var mediaItems = Array.from(root.querySelectorAll('[data-tls-pdp-media]'));

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
        mediaItems.forEach(function (m, n) { m.classList.toggle('is-active', n === i); });
      });
    });

    var qtyInput = root.querySelector('[data-tls-pdp-qty-input]');
    root.querySelectorAll('[data-tls-pdp-qty-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!qtyInput) return;
        var step = parseInt(btn.getAttribute('data-tls-pdp-qty-step'), 10);
        var next = Math.max(1, parseInt(qtyInput.value || '1', 10) + step);
        qtyInput.value = next;
      });
    });

    var form = root.querySelector('[data-tls-pdp-form]');
    if (!form) return;
    var variantsScript = form.querySelector('[data-tls-pdp-variants]');
    var variants = [];
    try {
      variants = JSON.parse(variantsScript.textContent);
    } catch (e) {}

    var optionSelects = Array.from(form.querySelectorAll('[data-tls-pdp-option]'));
    var variantIdInput = form.querySelector('[data-tls-pdp-variant-id]');
    var addBtn = form.querySelector('.tls-product__add');
    var addLabel = form.querySelector('[data-tls-pdp-add-label]');
    var priceWrap = root.querySelector('.tls-product__price');

    function money(cents) {
      if (window.TerralooSleek && window.TerralooSleek.formatMoney) {
        return window.TerralooSleek.formatMoney(cents);
      }
      return (cents / 100).toFixed(2);
    }

    function findVariant(selection) {
      return variants.find(function (v) {
        return v.options.every(function (opt, i) {
          return opt === selection[i];
        });
      });
    }

    function updateUI() {
      if (!optionSelects.length) return;
      var selection = optionSelects.map(function (s) { return s.value; });
      var match = findVariant(selection);
      if (!match) return;

      variantIdInput.value = match.id;

      if (priceWrap) {
        var html = '';
        if (match.compare_at_price && match.compare_at_price > match.price) {
          html += '<span class="tls-price tls-price--compare">' + money(match.compare_at_price) + '</span>';
          html += '<span class="tls-price tls-price--sale">' + money(match.price) + '</span>';
        } else {
          html += '<span class="tls-price">' + money(match.price) + '</span>';
        }
        priceWrap.innerHTML = html;
      }

      if (match.available) {
        addBtn.disabled = false;
        addLabel.textContent = window.TerralooSleek.strings.addToCart;
      } else {
        addBtn.disabled = true;
        addLabel.textContent = window.TerralooSleek.strings.soldOut;
      }
    }

    optionSelects.forEach(function (select) {
      select.addEventListener('change', updateUI);
    });
  });
})();
